export const LAPORAN_AKHIR_GET_REQUEST = "LAPORAN_AKHIR_GET_REQUEST";
export const LAPORAN_AKHIR_GET_SUCCESS = "LAPORAN_AKHIR_GET_SUCCESS";
export const LAPORAN_AKHIR_GET_FAIL = "LAPORAN_AKHIR_GET_FAIL";
export const LAPORAN_AKHIR_GET_RESET = "LAPORAN_AKHIR_GET_RESET";

export const LAPORAN_AKHIR_GENERATE_REQUEST = "LAPORAN_AKHIR_GENERATE_REQUEST";
export const LAPORAN_AKHIR_GENERATE_SUCCESS = "LAPORAN_AKHIR_GENERATE_SUCCESS";
export const LAPORAN_AKHIR_GENERATE_FAIL = "LAPORAN_AKHIR_GENERATE_FAIL";
export const LAPORAN_AKHIR_GENERATE_RESET = "LAPORAN_AKHIR_GENERATE_RESET";
